/** class for User object */
export class UserData {
  client_id: number;
  client_name: string;
}
